import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { MessageComponent } from "@/components/General/Messages/messages.component";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

const WishlistInfoblockContainer = () => {
    const customer = useSelector(getCustomer);
    const { t } = useGranite();

    const isLoggedIn = !!(customer && !customer.guest);

    if (isLoggedIn) {
        return null;
    }

    const redirectSearchParams = new URLSearchParams({
        redirectTo: Config.pages.wishlist
    });

    const loginUrl = `<a href="${
        Config.pages.login
    }?${redirectSearchParams.toString()}">${t("wishlist.info.text.login")}</a>`;

    return (
        <MessageComponent
            className={cn("tw:bg-grey! tw:border-grey-input!")}
            message={{
                title: t("wishlist.info.title"),
                text: t("wishlist.info.text", loginUrl),
                dismissible: false,
                status: "info",
                id: "empty-wishlist-id"
            }}
        />
    );
};

export { WishlistInfoblockContainer };
